<template>
  <div>
    <VBusHelper :reactOn="EVENTS.CART.SHOW" :handler="showCart" />
    <DialogComponent
      ref="dialog"
      dialogId="cart-dialog"
      type="fullscreen"
      noInnerPadding
      hideCloseButton
    >
      <CartBottomSheet
        v-if="/* !isLoading && */ cartData"
        :cartData="cartData"
        @close="hideCart"
        @addItem="onAddItem"
        @updateItem="onUpdateItem"
        @removeItem="onRemoveItem"
        @updateOptions="onUpdateOptions"
        @updateDrinks="onUpdateDrinks"
        @updateGlobalDrinks="onUpdateGlobalDrinks"
        @applyCoupon="onApplyCoupon"
        @removeCoupon="onRemoveCoupon"
        @checkout="onCheckout"
        @confirmOrder="onConfirmOrder"
      />
      <CartBottomSheetShimmer v-else />
    </DialogComponent>
  </div>
</template>

<script setup>
import { ref, computed, onBeforeUnmount, getCurrentInstance } from 'vue';
import CartBottomSheet from './CartBottomSheet.vue';
import CartBottomSheetShimmer from './CartBottomSheetShimmer.vue';

const dialog = ref(null);

// FIX: Race condition prevention
const isDialogOpen = ref(false);
const isOpening = ref(false);

// FIX: Use window.EVENTS

const { proxy } = getCurrentInstance();
const { $constants, $stores, $bus } = proxy;
const EVENTS = $constants.EVENTS;
const cartData = computed(() => $stores?.cart?.state?.cart);
const isLoading = computed(() => $stores?.cart?.isLoading ?? false);

const showCart = async () => {
  try {
    // Fetch latest cart from server
    $bus.emit(EVENTS.CART.LOAD);

    // Wait for cart to load (with timeout)
    // const timeout = new Promise((_, reject) =>
    //   setTimeout(() => reject(new Error('Cart load timeout')), 3000)
    // );

    // const cartLoaded = new Promise((resolve) => {
    //   const checkLoaded = () => {
    //     if (!isLoading.value) {
    //       resolve();
    //     } else {
    //       setTimeout(checkLoaded, 100);
    //     }
    //   };
    //   checkLoaded();
    // });

    // await Promise.race([cartLoaded, timeout]);

    // Show dialog
    dialog.value?.show();
    // isDialogOpen.value = true;
  } catch (error) {
    console.error('Error showing cart:', error);
    $bus.emit(EVENTS.TOAST_NOTIFICATION.SHOW, {
      message: 'Erreur lors du chargement du panier',
      type: 'error'
    });
  } finally {
    isOpening.value = false;
  }
};

const hideCart = () => {
  dialog.value?.hide();
  // isDialogOpen.value = false;
};

// FIX: Add null checks for all handlers
const onAddItem = (item) => {
  if (!item?.dishId) {
    console.error('Invalid item data:', item);
    return;
  }
  $bus.emit(EVENTS.CART.ITEMS.ADD, item);
};

const onUpdateItem = (data) => {
  if (!data?.itemId) {
    console.error('Invalid update data:', data);
    return;
  }
  $bus.emit(EVENTS.CART.ITEMS.UPDATE, data);
};

const onRemoveItem = (itemId) => {
  if (!itemId) {
    console.error('Invalid itemId:', itemId);
    return;
  }
  $bus.emit(EVENTS.CART.ITEMS.REMOVE, { itemId });
};

const onUpdateOptions = (data) => {
  if (!data?.itemId || !Array.isArray(data?.options)) {
    console.error('Invalid options update data:', data);
    return;
  }
  $bus.emit(EVENTS.CART.ITEMS.OPTIONS.UPDATE, data);
};

const onUpdateDrinks = (data) => {
  if (!data?.itemId || !Array.isArray(data?.drinks)) {
    console.error('Invalid drinks update data:', data);
    return;
  }
  $bus.emit(EVENTS.CART.ITEMS.DRINKS.UPDATE, data);
};

// Handler pour les boissons GLOBALES (pas par article)
const onUpdateGlobalDrinks = (drinks) => {
  if (!Array.isArray(drinks)) {
    console.error('Invalid global drinks data:', drinks);
    return;
  }
  $bus.emit(EVENTS.CART.DRINKS.UPDATE, { drinks });
};

const onApplyCoupon = (code) => {
  // TODO: Implement coupon logic
  console.log('Apply coupon:', code);
};

const onRemoveCoupon = () => {
  // TODO: Implement coupon removal
  console.log('Remove coupon');
};

const onCheckout = () => {
  // Navigate to checkout or emit order event
  $bus.emit(EVENTS.ORDER?.CREATE_FROM_CART || 'order.create');
};

const onConfirmOrder = (orderData) => {
  console.log('[CartDialog] confirmOrder received:', orderData);

  // Validate order data
  if (!orderData) {
    console.error('[CartDialog] Invalid order data');
    $bus.emit(EVENTS.TOAST_NOTIFICATION.SHOW, {
      type: 'error',
      title: 'Erreur',
      body: 'Données de commande invalides'
    });
    return;
  }

  // Emit order creation event with payment data
  // The orders controller will handle processPayment first, then createOrder
  $bus.emit(EVENTS.ORDERS.CREATE, {
    ...orderData,
    cartData: cartData.value,
    source: 'cart'
  });
};

// Auto-hide if cart becomes empty
const onCartCleared = () => {
      hideCart();
  // setTimeout(() => {
  //   if (isDialogOpen.value) {
  //     hideCart();
  //   }
  // }, 800);
};

// Handle order creation success
const onOrderCreated = (order) => {
  console.log('[CartDialog] Order created:', order);

  // Hide the cart dialog
  hideCart();

  // Clear local cart store
  $stores?.cart?.state?.cart && ($stores.cart.state.cart = null);

  // Navigate to orders list page
  $router.push('/orders');
};

// FIX: Proper cleanup to prevent memory leaks
$bus.on(EVENTS.CART.CLEARED, onCartCleared);
$bus.on(EVENTS.ORDERS.CREATED, onOrderCreated);

onBeforeUnmount(() => {
  $bus.off(EVENTS.CART.CLEARED, onCartCleared);
  $bus.off(EVENTS.ORDERS.CREATED, onOrderCreated);
});
</script>
